module.exports = __webpack_public_path__ + "static/img/x.bb66c4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/x.png
// module id = PO0z
// module chunks = 26